<template>
	<div class="modal" id="" tabindex="-1" role="dialog" :class="{ 'show':showModal }">
		<div class="modal-dialog" :class="{ 'show':showModal }">
			<div class="modal-content">
				<slot name="alert"></slot>
				<div class="modal-header">
					<slot name="header">
						<h4 class="modal-title">{{ modalTitle }}</h4>
					</slot>
				</div>

				<div class="modal-body">
					<slot name="body">
						{{ modalDescription }}
					</slot>
				</div>

				<div class="modal-footer">
					<slot name="footer"></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'modal',
	description: 'You can assign the custom options for header and body and footer.',
	props: {
		modalTitle: {
			type: String,
			default: '',
			note: 'set modal title'
		},
		modalDescription: {
			type: String,
			default: '',
			note: 'Assign description in body'
		},
		showModal: {
			type: Boolean,
			default: false,
			note: 'Show or hide modal'
		},
		clickButtonPrimary: {
			type: Function,
			note: 'Assign function to primary button'
		},
		primaryButtonText: {
			type: String,
			default: '',
			note: 'Primary button label'
		},
		primaryButtonId: {
			type: String,
			default: '',
			note: 'Primary button ID'
		},
		secondaryButtonText: {
			type: String,
			default: '',
			note: 'Secondary button label'
		},
		secondaryButtonId: {
			type: String,
			default: '',
			note: 'Secondary button ID'
		}
	},
};
</script>

<style lang="less" scoped>
	.modal {
		display: none;
		font-size: 14px;
		line-height: 2em;
		.alert {
			position:relative !important;
			animation: none !important;
		}
		&.show {
			display: block;
		}
		.modal-dialog {
			&.show {
				animation: slide-down .3s ease-out;
				@keyframes slide-down {
					0% { opacity: 0; -webkit-transform: translateY(-100%); }
					100% { opacity: 1; -webkit-transform: translateY(0); }
				}
			}
		}
		.btn-block {
			margin-top: 0;
		}
		.submit-button-group {
			margin-top: -10px;
		}
	}
</style>
